import * as XLSX from 'xlsx'
import { parseCsv } from './utils'
import {
  FORNECEDOR_TEMPLATE_HEADERS,
  FORNECEDOR_TEMPLATE_ROW,
  parseFornecedorRows,
  type FornecedorImportRow,
} from './fornecedorService'

export function downloadFornecedorTemplateXlsx() {
  const ws = XLSX.utils.json_to_sheet([FORNECEDOR_TEMPLATE_ROW], {
    header: [...FORNECEDOR_TEMPLATE_HEADERS],
  })
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Fornecedores')
  XLSX.writeFile(wb, 'modelo-fornecedores.xlsx')
}

export async function parseFornecedorFile(file: File): Promise<FornecedorImportRow[]> {
  const name = file.name.toLowerCase()
  if (name.endsWith('.xlsx') || name.endsWith('.xls')) {
    const buffer = await file.arrayBuffer()
    const wb = XLSX.read(buffer, { type: 'array' })
    const sheet = wb.Sheets[wb.SheetNames[0]]
    const rows = XLSX.utils.sheet_to_json<Record<string, string>>(sheet, { defval: '' })
    return parseFornecedorRows(
      rows.map((r) =>
        Object.fromEntries(Object.entries(r).map(([k, v]) => [k.trim(), String(v ?? '').trim()])),
      ),
    )
  }

  if (name.endsWith('.csv')) {
    const text = await file.text()
    return parseFornecedorRows(parseCsv(text))
  }

  throw new Error('Formato não suportado. Use .xlsx, .xls ou .csv')
}
